export default __webpack_public_path__ + "static/media/onboarding_gifts_2.0c437b47.png";